var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPageCount)?_c('h3',{staticClass:"configurator-additional-info"},[_c('strong',[_vm._v(_vm._s(_vm.pageCount))]),_vm._v(" pagina's "),(_vm.allPageCounts.altered)?_c('span',[_vm._v("("+_vm._s(_vm.allPageCounts.file)+" pdf-pagina's)")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e988a7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price-pages.vue
// module id = null
// module chunks = 